var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading_pdf)?_c('Loading'):_c('button',{staticClass:"btn btn-sm btn-primary ml-2 mr-2",on:{"click":_vm.init}},[_c('font-awesome-icon',{attrs:{"icon":"file-pdf"}}),_vm._v(" PDF\n    ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }